import '../styles/digix-ui.css';
import { ContainerDeMensagensFlutuantes } from '@digix-ui/componentes';

import { routesConfig } from 'config';
import { useAuth } from 'hooks';
import { useProductFruits } from 'hooks/use-product-fruits';
import { RouterCreator } from 'router';

function AuthenticatedProductFruits() {
  const { nome, documento } = useAuth();
  const productFruits = useProductFruits();

  if (!nome || !documento) {
    return null;
  }

  return productFruits;
}

export function AppContext(): JSX.Element {
  return (
    <>
      <AuthenticatedProductFruits />
      <ContainerDeMensagensFlutuantes />
      <RouterCreator
        routesConfig={routesConfig}
        redirectPath="/"
        fallbackRedirectPath="/"
      />
    </>
  );
}
